import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgZone } from '@angular/core';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { SafeHtmlPipe, SanitizerValueType } from '@pipes/safe-html/safe-html.pipe';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ui-message',
  standalone: true,
  imports: [
    CommonModule,
    SafeHtmlPipe,
    SvgIconComponent,
  ],
  templateUrl: './ui-message.component.html',
  styleUrl: './ui-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        opacity: 0,
      })),
      transition('inactive => active', animate('400ms ease-out', keyframes([
        style({
          transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
          opacity: 0,
        }),
        style({
          transform: 'skewX(20deg)',
          opacity: 1,
        }),
        style({
          transform: 'skewX(-5deg)',
          opacity: 1,
        }),
        style({
          transform: 'none',
          opacity: 1,
        }),
      ]))),
      transition('active => removed', animate('400ms ease-out', keyframes([
        style({
          opacity: 1,
        }),
        style({
          transform: 'translate3d(100%, 0, 0) skewX(30deg)',
          opacity: 0,
        }),
      ]))),
    ]),
  ],
})
export class UiMessageComponent extends Toast  {

  undoString = 'undo';
  type: 'success' | 'warning' | 'error' | 'info' = 'success'

  readonly SanitizerValueType = SanitizerValueType;

  constructor(
    public toastrService: ToastrService,
    public toastPackage: ToastPackage,
    public ngZone: NgZone
  ) {
    super(toastrService, toastPackage, ngZone);
    this.checkType();
  }

  checkType() {
    if (this.toastClasses.includes('error')) {
      this.type = 'error'
    }
    if (this.toastClasses.includes('success')) {
      this.type = 'success'
    }
    if (this.toastClasses.includes('warning')) {
      this.type = 'warning'
    }
    if (this.toastClasses.includes('info')) {
      this.type = 'info'
    }
  }

  action(event: Event) {
    event.stopPropagation();
    this.undoString = 'undid';
    this.toastPackage.triggerAction();
    return false;
  }
}
